export const campaignPhoneNumbers = {
	"Google-PPC_NZ_Generic": {
		nz: {
			number: "09 918 2533",
			telephone: "+6499182533"
		},
		au: {
			number: "",
			telephone: ""
		},
		us: {
			number: "",
			telephone: ""
		},
		uk: {
			number: "",
			telephone: ""
		},
		worldwide: {
			number: "",
			telephone: ""
		}
	},
	"Google-PPC_NZ_Brand": {
		nz: {
			number: "09 918 2533",
			telephone: "+6499182533"
		},
		au: {
			number: "",
			telephone: ""
		},
		us: {
			number: "",
			telephone: ""
		},
		uk: {
			number: "",
			telephone: ""
		},
		worldwide: {
			number: "",
			telephone: ""
		}
	},
	"Bing_NZ-PPC-Generic": {
		nz: {
			number: "09 918 2555",
			telephone: "+6499182555"
		},
		au: {
			number: "",
			telephone: ""
		},
		us: {
			number: "",
			telephone: ""
		},
		uk: {
			number: "",
			telephone: ""
		},
		worldwide: {
			number: "",
			telephone: ""
		}
	},
	"Bing_NZ-PPC-Brand": {
		nz: {
			number: "09 918 2555",
			telephone: "+6499182555"
		},
		au: {
			number: "",
			telephone: ""
		},
		us: {
			number: "",
			telephone: ""
		},
		uk: {
			number: "",
			telephone: ""
		},
		worldwide: {
			number: "",
			telephone: ""
		}
	}
}
